import { Currency, TraitSale } from "types";
import axios from "axios";
import { apiUrl } from "config";
import { BigNumber } from "ethers";

export type FetchTraitSalesData = { currency: Currency; address?: string };

export const fetchTraitSales = async ({
  currency,
  address,
}: FetchTraitSalesData): Promise<TraitSale[]> => {
  const res = await axios.get<TraitSale[]>(`/trait-sales`, {
    baseURL: apiUrl,
    params: {
      currency,
    },
    headers: address
      ? {
          Wallet: address,
        }
      : undefined,
  });

  return res.data.map((sale) => ({
    ...sale,
    price: BigNumber.from(sale.price),
  }));
};
